import {compile, empty, log} from "@lernetz/ts-lib/src/view/Compiler";
import {getState} from "../state";

class ApiService {
    private interceptors: Function[] = [];
    async get(uri) {
        const request = new Request(uri);
        const processedRequest = this.applyInterceptors(request)
        const res =  await fetch(processedRequest)
        return res.json();
    }

    async post(uri, body) {
        const request = new Request(uri, {
            method: "POST",
            body
        });
        const processedRequest = this.applyInterceptors(request)
        const res =  await fetch(processedRequest)
        return res.json();
    }

    private applyInterceptors(request: Request) {
        let processedRequest = { ...request };
        this.interceptors.forEach( interceptor => {
            processedRequest = interceptor(processedRequest)
        })
        return processedRequest;
    }

    addInterceptor() {

    }

}

export const httpService = new ApiService();

export function lookup(key) {
    const data = getState();
    const c = compile( '[[ ' + key + ' ]]' ).call( { empty:empty, log:log }, data.routes );
    if( !c ) throw new Error( "Route: '" + key + "' could not be found in setup routes." );
    return c;
}

